
import React from 'react';
import { motion } from 'framer-motion';

const IframePage = () => {
  return (
    <div className="container mx-auto px-4 py-8 section-padding">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="page-title mb-8"
      >
        Geïntegreerde Applicatie
      </motion.h1>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="bg-white p-4 sm:p-6 rounded-xl shadow-2xl overflow-hidden"
      >
        <iframe
          src="https://jouw-horizons-app.tld"
          width="100%"
          height="600"
          style={{ border: 'none', borderRadius: '8px' }}
          title="Geïntegreerde Applicatie"
          allowFullScreen
        ></iframe>
      </motion.div>
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        className="text-cm-gray mt-6 text-center text-sm"
      >
        Let op: De content hierboven wordt geladen van een externe bron. Zorg ervoor dat de URL correct is ingesteld.
        Als 'jouw-horizons-app.tld' de URL van deze Classbuddy app zelf is, kan dit een oneindige lus veroorzaken.
      </motion.p>
    </div>
  );
};

export default IframePage;
